export default __webpack_public_path__ + "static/media/new-casino.a0aa19b8.svg";